module.exports = __webpack_public_path__ + "img/stop-2.aef9031e.jpg";